import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowService {
  baseUrl = environment.baseUrl;
  private adminSource = new BehaviorSubject<any>(false);
  kpiData: any;
  kpiLoader = false;

  private adminDetailsSource = new BehaviorSubject<any>({});
  adminDetailsFound = false;
  adminDetailsFoundHeader = false;
  activeRoles = []
  currentRole: any;
  constructor(private http: HttpClient) {
    this.getKPIDetails();
  }

  setAdminValue(value: boolean) {
    this.adminSource.next(value);
  }

  get isAdmin() {
    return this.adminSource.getValue();
  }

  setAdminDetails(value) {
    this.adminDetailsSource.next(value);
  }

  get adminDetails() {
    return this.adminDetailsSource.asObservable();
  }


  getAdminRoles() {
    return this.http.get<any>(this.baseUrl + '/services/core/admins/api/v1/all_roles').subscribe(res => {
      this.adminDetailsSource.next(res);
      this.adminDetailsFound = true;
      this.adminDetailsFoundHeader = true;
    })
  }

  getKPIDetails(){
    this.kpiLoader = true;
    return this.http.get<any>(this.baseUrl + '/services/core/admins/api/v1/kpi_details').subscribe(res => {
      this.kpiLoader = false;
      this.kpiData = res.result;
    })
  }

  getCurrentRoles() {
    return this.http.get<any>(this.baseUrl + '/services/core/admins/api/v1/current_admin_roles').pipe(tap(res => {
      this.adminDetailsSource.next(res);
      this.adminDetailsFound = true;
      this.adminDetailsFoundHeader = true;

      res.roles.forEach(element => this.activeRoles.push(element.key));
      this.currentRole = this.getPriorityRole()
    }));
  }

  getPriorityRole() {
    if(this.isIncluded('admin')) {
      return 'Admin';
    } else if(this.isIncluded('bpm')) {
      return 'HP Business Partner Manager'
    } else if(this.isIncluded('hp_channel_manage')) {
      return 'HP Reseller Manager'
    } else if(this.isIncluded('field_engineer')) {
      return 'HP Field Engineer'
   }  else if(this.isIncluded('hp_call_center')) {
      return 'HP Call Center'
   }  else if(this.isIncluded('hp_viewer')) {
      return 'HP Viewer'
   }  else {
      return null;
   }
   }
 
   isIncluded(key) {
     return this.activeRoles.includes(key);
   }


}
